module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To my wife Carol for her enthusiasm, encouragement and skill in correcting my grammar. Thank you is an insufficient word to express my gratitude.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To my many surgical colleagues and all the patients who placed their trust in me. Without them none of the events described would have taken place.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("To the endlessly patient staff of Austin Macauley who guided me through the unfamiliar world of publication. Thank you for bringing this work to fruition.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0